import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import {
    selectEntities,
    selectEntityIdProp
} from 'services/entities/selectors';
// @ts-ignore
import { makeSelectHarvestSchemaValue } from 'services/schemas/selectors';

import { getEntityVarietyId } from 'services/entities/utils';

const selectVariety = createDeepEqualSelector(
    makeSelectHarvestSchemaValue('entityTypeId'),
    selectEntityIdProp,
    selectEntities,
    (schemaEntityTypeId, entityId, entities) => {
        let varietyId = null;

        if (entityId && schemaEntityTypeId) {
            varietyId = getEntityVarietyId(
                entityId,
                entities,
                schemaEntityTypeId as number
            );
        }

        return varietyId;
    }
);

const makeSelectVariety = (): typeof selectVariety => selectVariety;

export { makeSelectVariety };
